/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { Component, Input } from "@angular/core";
import { FavouritesStorage, FavouritesStorageProvider } from "core-library/components/favourites/favourites-storage.service";

import { SearchConfigurationModel } from "../../../models/search-configuration.model";
import { SearchFilterModel } from "../../../models/search-filter.model";
import { SearchResultItemModel } from "../../../models/search-result-item.model";
import { SearchParametersService } from "../../../services/search-parameters.service";

@Component({
    selector: "[pcg-ng-result-item]",
    templateUrl: "./result-item.component.html",
    providers: [FavouritesStorageProvider]
})
export class ResultItemComponent {
    @Input()
    public model: SearchResultItemModel = null;

    @Input()
    public searchConfiguration: SearchConfigurationModel;

    @Input()
    public searchParameters: SearchFilterModel;

    public constructor(
        private _favouritesStorage: FavouritesStorage,
        private _searchParametersFactory: SearchParametersService
    ) {
    }

    // public get isInBookmark(): boolean {
    //     return this._favouritesStorage.has(this.model.key);
    // }

    // public onToggleBookmark(): void {
    //     if (this.isInBookmark) {
    //         this._favouritesStorage.remove(this.model.key);
    //     } else {
    //         this._favouritesStorage.add(this.model.key);
    //     }
    // }

    public getDetailsPageUrl(): string {
        let url = `${this.model.url}`;

        const searchParameters = this.getNonDefaultSearchParameters(this.searchParameters);
        if (searchParameters && (Object.keys(searchParameters).length > 0)) {
            url += `?searchParams=${JSON.stringify(searchParameters)}`;
        }

        return url;
    }

    private getNonDefaultSearchParameters(obj: any): any {
        const defaultSearchParameters = this._searchParametersFactory.create("", this.searchConfiguration);
        const nonDefaultSearchParameters = {};

        for (const key in obj) {
            if (key === "datesRange") {
                nonDefaultSearchParameters[key] = obj[key];
                continue;
            }

            if (obj.hasOwnProperty(key) && (obj[key] !== undefined) && (obj[key] !== null) && (obj[key] !== "") && (obj[key].length > 0)) {
                if ((key === "pageNumber") && (obj[key] === defaultSearchParameters.pageNumber)) {
                    continue;
                }
                if ((key === "pageSize") && (obj[key] === defaultSearchParameters.pageSize)) {
                    continue;
                }
                nonDefaultSearchParameters[key] = obj[key];
            }
        }

        return nonDefaultSearchParameters;
    }
}
